import { defineNuxtPlugin } from '#app';
import { DateTime } from 'luxon';

export default defineNuxtPlugin(() => ({
    provide: {
        locator: {
            getTodayOpeningHours(openingHours, translator = null) {
                const today = DateTime.now().toFormat('yyyy-MM-dd');

                const open24h = openingHours?.filter(item =>
                    item?.openHours?.[0]?.startTime === '00:00:00'
                    && item?.openHours?.[0]?.endTime === '24:00:00')?.length === 8
                    || false;

                if (openingHours && open24h) {
                    if (translator) {
                        return translator.t('open24h');
                    }

                    return 'Open 24h';
                } else if (typeof(openingHours) === 'object') {
                    try {
                        const { openHours } = openingHours.find(item => item.date === today) || [];

                        return openHours.map(item => `${item.startTime.replace(/:00$/, '')} - ${item.endTime.replace(/:00$/, '')}`).join(', ');
                    } catch (e) {
                        return '-';
                    }
                }

                return '-';
            },
            parseOpenHoursRows(openingHours, translator = null) {
                const translate = translator ? translator.t : (v => v);
                const today = DateTime.now().toFormat('yyyy-MM-dd');
                const tomorrow = DateTime.now().plus({ days: 1 }).toFormat('yyyy-MM-dd');

                if (openingHours.store24h) {
                    return [{
                        label: translate('open24h'),
                    }];
                }

                return openingHours.storeOpeningHours.filter(item => DateTime.fromFormat(item.date, 'yyyy-MM-dd').toMillis() > DateTime.now().minus({ days: 1 }).toMillis()).map(item => ({
                    label: item.date === today
                        ? translate('day.today')
                        : (item.date === tomorrow
                            ? translate('day.tomorrow')
                            : translate(`day.${DateTime.fromFormat(item.date, 'yyyy-MM-dd').toFormat('E')}`)
                        ),
                    hours: item.hours.map(entry => `${entry.opens} - ${entry.closes}`).join(', '),
                }));
            },
            markerDataStructure({ station, path }) {
                return {
                    id: station.id,
                    brand: station.brand,
                    name: station.name,
                    isClosed: station.isClosed,
                    position: {
                        lat: Number(station.location?.lat),
                        lng: Number(station.location?.lon),
                    },
                    path,
                };
            },
        },
    },
}));
